import styled, { css } from 'styled-components'

export const PaginationButton = styled.button`
  ${({ theme }) => css`
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 5px;

    span {
      :hover {
        color: ${theme.colors.blues.A800};
      }
    }
  `}
`
